import { render, staticRenderFns } from "./AppointmentDeletedToAssistant.vue?vue&type=template&id=5bd387f9"
import script from "./AppointmentDeletedToAssistant.vue?vue&type=script&lang=js"
export * from "./AppointmentDeletedToAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports